export const ItemTypes = {
  COMPONENT: 'component'
}
